import { render, staticRenderFns } from "./DialogChangeStatus.vue?vue&type=template&id=1d9d5db1&scoped=true&"
import script from "./DialogChangeStatus.ts?vue&type=script&lang=ts&"
export * from "./DialogChangeStatus.ts?vue&type=script&lang=ts&"
import style0 from "./DialogChangeStatus.vue?vue&type=style&index=0&id=1d9d5db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d5db1",
  null
  
)

export default component.exports
import {QSpinnerAudio,QSelect,QSeparator,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerAudio,QSelect,QSeparator,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
